'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import ReviewExerciseConfirmModal from '../../../components/Modals/ConfirmModals/ReviewExerciseConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class PracticalExerciseReviewButton extends Component {
  constructor(props) {
    super(props);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleModalClosed = this.handleModalClosed.bind(this);
    this.handleModalConfirmed = this.handleModalConfirmed.bind(this);
    this.state = {
      confirmModalOpen: false
    };
  }
  handleOpenModal() {
    this.setState({
      confirmModalOpen: true
    });
  }
  handleModalClosed() {
    this.setState({
      confirmModalOpen: false
    });
  }
  handleModalConfirmed() {
    this.props.onConfirm();
    this.handleModalClosed();
  }
  renderModal() {
    const {
      graded,
      isManual
    } = this.props;
    return /*#__PURE__*/_jsx(ReviewExerciseConfirmModal, {
      graded: graded,
      isManual: isManual,
      onConfirm: this.handleModalConfirmed,
      onReject: this.handleModalClosed
    });
  }
  render() {
    const {
      className,
      disabled,
      labelI18n,
      use
    } = this.props;
    return /*#__PURE__*/_jsxs("span", {
      className: className,
      children: [this.state.confirmModalOpen && this.renderModal(), /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "practical-exercise-review-button",
        disabled: disabled,
        onClick: this.handleOpenModal,
        use: use,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: labelI18n
        })
      })]
    });
  }
}
PracticalExerciseReviewButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  graded: PropTypes.bool,
  isManual: PropTypes.bool,
  labelI18n: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  use: PropTypes.string
};
PracticalExerciseReviewButton.defaultProps = {
  labelI18n: 'learningCenter.practicalExercise.external.started.checkMyWork',
  use: 'primary'
};
export default PracticalExerciseReviewButton;